import { PixiBase } from '../core/pixi/PixiBase';
import { mobileGameConfigs, webGameConfigs } from '../core/pixi/config';
import { Spine } from '../services/elementTypeService/Spine';
import { Container } from '../services/elementTypeService/Container';
import { gameMainDrawer } from '../game/drawers/gameMainDrawer';
import { gameLiveConnection } from '../services';
import { winBarStore } from '../store/winBarStore';
import { jackpotIcons } from '../enums/jackpotIcons';
import { isMobile } from './isMobile';

const config = isMobile() ? mobileGameConfigs : webGameConfigs;
let interval = null;
let timer = null;

export const createJackpotAmountSymbols = (texture) => {
  const distanceSymbolsX = config.JackpotContainer.jackpotAmountSymbols;
  const jackpotAmountSymbolsContainer = new Container({});
  // PixiBase.createContainer('jackpotAmountSymbolsContainer');
  for (let i = 0; i <= 2; i += 1) {
    const symbol = PixiBase.createSprite(texture);
    symbol.id = i;
    symbol.x = distanceSymbolsX[i];
    if (i === 1) {
      if (isMobile()) {
        symbol.scale.set(1);
      } else {
        symbol.scale.set(0.8);
      }
    }
    if (i !== 1) {
      if (isMobile()) {
        symbol.scale.set(0.75);
      } else {
        symbol.scale.set(0.6);
      }
    }
    jackpotAmountSymbolsContainer.addChild(symbol);
  }
  return jackpotAmountSymbolsContainer;
};
export const createJackpotSymbolContainer = (textureContainer, jackpotIcon) => {
  const jackpotSymbolsContainer = PixiBase.createContainer('jackpotSymbolsContainer');
  // eslint-disable-next-line no-use-before-define,no-shadow
  const jackpotIcons = createJackpotIcons(jackpotIcon);
  jackpotSymbolsContainer.addChild(jackpotIcons);
  const jackpotIconsSpriteContainer = PixiBase.createContainer('jackpotIconsSpriteContainer');
  const distanceSymbolsPosition = config.JackpotContainer.jackpotSymbolsContainerPositionList;
  for (let i = 0; i < distanceSymbolsPosition.length; i += 1) {
    const jackpotSymbolContainer = new Spine({ key: textureContainer });
    const jackpotIconsSprite = new Spine({ key: jackpotIcon });
    jackpotIconsSprite.play('idle', true);
    jackpotIconsSprite.visible = false;
    jackpotIconsSprite.cardType = jackpotSymbolContainer.id = distanceSymbolsPosition[i].id;
    jackpotIconsSprite.id = distanceSymbolsPosition[i].id;
    jackpotSymbolContainer.x = distanceSymbolsPosition[i].x;
    jackpotSymbolContainer.y = distanceSymbolsPosition[i].y;
    jackpotIconsSprite.x = distanceSymbolsPosition[i].x;
    jackpotIconsSprite.y = distanceSymbolsPosition[i].y;
    jackpotIconsSpriteContainer.addChild(jackpotIconsSprite);
    jackpotSymbolsContainer.addChild(jackpotSymbolContainer);
    jackpotSymbolsContainer.addChild(jackpotIconsSpriteContainer);
  }
  return jackpotSymbolsContainer;
};
const createJackpotIcons = (icon) => {
  const jackpotIconsContainer = PixiBase.createContainer('jackpotIconsContainer');
  const distanceSymbolsPosition = config.JackpotContainer.jackpotSymbolsContainerPositionList;
  for (let i = 0; i < distanceSymbolsPosition.length; i += 1) {
    // eslint-disable-next-line no-shadow
    const jackpotIcon = new Spine({ key: icon });
    jackpotIcon.id = distanceSymbolsPosition[i].id;
    // jackpotIcon.cardType = distanceSymbolsPosition[i].id;
    jackpotIcon.x = distanceSymbolsPosition[i].x;
    jackpotIcon.y = distanceSymbolsPosition[i].y;
    jackpotIconsContainer.addChild(jackpotIcon);
  }
  return jackpotIconsContainer;
};
// eslint-disable-next-line default-param-last
export const updateExpiresCount = (dateMls = Date.now() + 300 * 1000, isShowWheel = false) => {
  const delay = Math.abs(Date.now() - dateMls);
  if (interval) {
    if (!isShowWheel) {
      gameMainDrawer.jackpotBar.dateText.text = '05:00';
    }
    clearInterval(interval);
    interval = null;
  }
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  interval = setInterval(() => {
    const timeInterval = Math.abs(Date.now() - dateMls);
    let minutes = Math.floor(timeInterval / 60000);
    if (String(minutes).length <= 1) {
      minutes = `0${minutes}`;
    }
    let second = Math.floor((timeInterval % 60000) / 1000);

    if (String(second).length <= 1) {
      second = `0${second}`;
    }
    if (!isShowWheel) {
      gameMainDrawer.jackpotBar.dateText.text = `${minutes}:${second}`;
    }
    if (!isShowWheel) {
      if (+minutes < 1 && +second < 5) {
        gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children.forEach((el) => {
          if (el.key === 'jackpotSymbolContainer') {
            el.interactive = false;
            el.buttonMode = false;
          }
        });
      }
    }
  }, 1000);

  timer = setTimeout(() => {
    clearInterval(interval);
    clearTimeout(timer);
    if (isShowWheel) {
      gameMainDrawer.boostedWheel.spinToStopSector(null);
    } else {
      gameLiveConnection.getJackpotScene();
    }
  }, delay);

  // return `${minutes}:${second}`;
};

export const openExpiresData = (jackpotSceneItemInfo) => {
  gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children.forEach((el) => {
    if (el.key === 'jackpotSymbolContainer') {
      if (el.getCurrentAnimationName() !== 'open') {
        el.play('open');
      }
    }
  });
  jackpotSceneItemInfo.forEach((el) => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children[0].children[
      el.index - 1
    ].visible = true;

    gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children[0].children[
      el?.index - 1
    ].play('win', false);
    gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children[0].children[
      el?.index - 1
    ].skeleton.setSkinByName(jackpotIcons[el?.jackpotCard]);
    if (el.isWin) {
      gameMainDrawer.jackpotBar.startJackpotWinPopupAnimation(el.winAmount, el.jackpotCard);
    }
  });
};

export const clearJackPotTimeout = () => {
  clearInterval(interval);
  clearTimeout(timer);
  timer = null;
  interval = null;
};
